<div class="d-flex flex-column h-100">
  <div
    class="content__info {{ page ? 'h-100' : '' }}"
    [hidden]="commentList.length == 0"
    [scrollWindow]="false"
    infiniteScroll
    [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="20"
    (scrolledUp)="scrool()"
    #commentContainer
  >
    <div *ngFor="let data of commentList; let i = index" class="list" (click)="closeDropdown()">
      <div class="user__popup">
        <div class="user__infos">
          <img
            (click)="userSearch(data.userId)"
            [src]="data?.user?.profilePicture ? fileDirectoriesPath + data?.user?.profilePicture : 'assets/images/img_profile.png'"
            alt="User Image"
            class="user__images handPointer {{ userDetail.id == data?.userId ? 'row--highlight' : '' }}"
          />
          <div class="user__detail">
            <h2 class="user__name">{{ data.user?.alias ? data.user?.alias || '-' : data?.user?.name || '-' }}</h2>

            <span class="row--highlight badge" *ngIf="userDetail?.id == data?.userId">You</span>
          </div>
        </div>
        <div class="user__tags">
          <span>{{ data?.createdAt | date: DATE_FORMAT }}</span>
        </div>
      </div>
      <div class="comment_msg user-directory__action" *ngIf="editId != data?.commentId" container="body" ngbDropdown placement="bottom-end">
        {{ data?.comment }}
        <div class="info__more_action" *ngIf="userDetail.id == data?.userId || ReportedComment(data, i)">
          <button ngbDropdownToggle data-bs-toggle="dropdown" class="user-directory__action-btn" (click)="toggleDropdown(i)">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
              <path
                d="M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z"
              />
            </svg>
          </button>

          <div class="dropdown-menu_feed dropdown__option--small" [class.show]="activeDropdown === i" ngbDropdownMenu>
            <ul ngbDropdownItem>
              <li class="dropdown__option--list handPointer" (click)="report(data)" *ngIf="userDetail.id != data?.userId">
                <a>Report</a>
              </li>

              <li class="dropdown__option--list handPointer" *ngIf="userDetail.id == data?.userId" (click)="editable(1, i)">
                <a class="dropdown__item">Edit</a>
              </li>

              <li
                class="dropdown__option--list handPointer"
                *ngIf="userDetail.id == data?.userId"
                (click)="deleteComment(data?.commentId, DetailsFeed.id)"
              >
                <a class="dropdown__item">Delete</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="update" *ngIf="editId == data?.commentId">
        <input class="edit_box" [(ngModel)]="EditContent" (keyup.enter)="showSubmit(EditContent || '') ? editable(3, i) : false" />
        <div class="popup__footer">
          <button class="popup__button popup__clear" (click)="editable(2, i)">Cancel</button>
          <button class="popup__button popup__apply" *ngIf="showSubmit(EditContent || '')" (click)="editable(3, i)">Update</button>
        </div>
      </div>
    </div>
  </div>
  <div class="searchResult" *ngIf="commentList.length == 0">
    <div class="searching text-center">
      <h5>No comment found!</h5>
    </div>
  </div>
  <!-- <div class="inputBox">
  <input placeholder="Write your comment here…" (key.enter)="submitComment()" [(ngModel)]="searchContent" />
  <span class="send" *ngIf="showSubmit(searchContent || '')" (click)="submitComment()"></span>
</div> -->
  <div class="inputBox marging_top_auto">
    <textarea
      class="inputBox__textarea"
      placeholder="Write your comment here…"
      (keyup.enter)="showSubmit(searchContent || '') ? submitComment() : false"
      [(ngModel)]="searchContent"
      row="5"
    ></textarea>
    <span class="send senticon" *ngIf="showSubmit(searchContent || '')" (click)="submitComment()"> </span>
  </div>
</div>
